import React, { PropsWithChildren, useRef } from 'react';
import { TimedCookie, useCookie } from 'utils/cookie';
import { Announcement, AnnouncementDismissalReason, AnnouncementProps } from './Announcement';
import { CookieGate } from '../CookieGate/CookieGate';
import { gtag } from 'utils/analytics';
import { isTruthyString } from 'utils/parser';

export type StatefulAnnouncementProps = {
  announcement: Omit<AnnouncementProps, 'onDismiss'>;
  readonly cookie: TimedCookie;
};

/**
 * An announcement that is hooked up to a cookie and disappears
 * after interaction/closing.
 * @param children
 * @param announcement
 * @param cookie
 * @constructor
 */
export function StatefulAnnouncement({
  children,
  announcement,
  cookie,
}: PropsWithChildren<StatefulAnnouncementProps>) {
  const state = useCookie(cookie, isTruthyString);
  const mountTime = useRef(new Date());

  function onDismiss(reason: AnnouncementDismissalReason) {
    const dismissTime = new Date().getTime() - mountTime.current.getTime();

    console.group(`Dismissing announcement`);
    console.log(`Marked: ${cookie.name}`);
    console.log(`Dismissed in: ${dismissTime}ms`);
    console.log(`Dismiss reason: ${reason}`);
    console.groupEnd();

    gtag('event', 'dismiss announcement', {
      dismissTime,
      name: cookie.name,
      reason,
    });

    state.setCookie(true);
  }

  return (
    <CookieGate cookieState={state}>
      <Announcement onDismiss={onDismiss} {...announcement}>
        {children}
      </Announcement>
    </CookieGate>
  );
}
